import React, { Component } from 'react';
import { connect } from 'react-redux';
import Plate from "../../components/Plate/Plate";
import PlateCard from "../../components/PlateCard/PlateCard";
import Icon from "../../components/Icon/Icon";
import { initLoad } from "../../reducers/applicationReducer";
import moment from 'moment';

class OfferTerms extends Component {
  componentDidMount() {
    if (!Array.isArray(this.props.actions) || this.props.actions.length === 0) {
      this.props.initLoad();
    }
  }

  formatNumber = (number) => {
    return String(number).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  toPercentNoRound = (num) => {
    const scaled = Math.trunc((num * 100) * 1e12) / 1e12;
    return scaled;
  }


  render() {
    let {terms, actions, selectedActionId} = this.props;
  
        const selectedAction = selectedActionId && selectedActionId !== "0" && actions && actions.length > 0
      ? actions.find(action => action.label?.id.toString() === selectedActionId.toString())
      : null;
        
    let amount = terms.amount !== undefined ? this.formatNumber(terms.amount) : "";
    let monthlyRepayment = terms.monthlyRepayment !== undefined ? this.formatNumber(terms.monthlyRepayment).split('.')[0] : "";
    let requiredPrepayment = terms.requiredPrepayment !== undefined ? this.formatNumber(terms.requiredPrepayment) : "";
    let monthlyFee = terms.monthlyFee !== undefined ? this.formatNumber(terms.monthlyFee) : "";
    let rate =  terms.rate != null ? this.toPercentNoRound(terms.rate) : "";

    return (
      <>
      <div className="row mb_30">
        <div className="column small-12 medium-3">
          <Plate label="Վարկի գումար" value={amount} type={<Icon type="dram" size={15} />} theme="green" />
        </div>
        <div className="column small-12 medium-3">
          <Plate label="Տևողություն" value={terms.duration} type="ամիս" theme="grey" />
        </div>
        <div className="column small-12 medium-3">
          <Plate label="Ամսական ընդհանուր վճար" value={monthlyRepayment} type={<Icon type="dram" size={15} />} theme="grey" />
        </div>
        {selectedAction && (
            <div className='column small-12 medium-3'>
             <div className="action-result">
              <div className="action-name">{selectedAction.label.name}</div>
              {selectedAction.label.start && selectedAction.label.end && (
                <div className="action-date"><Icon type="date" size={10}/>{moment(selectedAction.label.start).format('DD/MM/YYYY')} - {moment(selectedAction.label.end).format('DD/MM/YYYY')}</div>
              )}
              {(selectedAction.label?.interestRateAfterGracePeriod != null || selectedAction.label?.interestRateInGracePeriod != null || selectedAction.label?.interestRateRepaymentGracePeriod != null || selectedAction.label?.principalRepaymentGracePeriod != null) && (
                <div className="action-infos">
                    {selectedAction.label?.principalRepaymentGracePeriod != null && (
                      <div className="action-info"><Icon type="done" size={8}/>
                        {selectedAction.label.principalRepaymentGracePeriod} ամիս միայն տոկոսի մարում
                      </div>
                    )}
                    {selectedAction.label?.principalRepaymentGracePeriod != null && (
                      <div className="action-info"><Icon type="done" size={8}/>
                        Հաջորդ ամիսներին՝ ամսական հավասարաչափ
                      </div>
                    )}
                    {selectedAction.label?.interestRateRepaymentGracePeriod != null && selectedAction.label?.interestRateInGracePeriod != null && (
                      <div className="action-info"><Icon type="done" size={8}/>
                        1-{selectedAction.label.interestRateRepaymentGracePeriod} ամիս՝ {this.toPercentNoRound(selectedAction.label.interestRateInGracePeriod)}%
                      </div>
                    )}
                    {selectedAction.label?.interestRateAfterGracePeriod != null && (
                      <div className="action-info"><Icon type="done" size={8}/>
                        Հաջորդ ամիսներին՝ {this.toPercentNoRound(selectedAction.label.interestRateAfterGracePeriod)}%
                      </div>
                    )}
                </div>
              )}
             </div>
            </div>
          )}
      </div>

      <div className="plate_data mb_25">
        <div className="row">
          <PlateCard className="column small-12 medium-3" label="Կանխավճար" value={requiredPrepayment} suffix={<Icon type="dram" size={17} />} />
          <PlateCard className="column small-12 medium-3" label="Տոկոսադրույք" value={rate} suffix="%" />
          <PlateCard className="column small-12 medium-3" label="Ամսական սպասարկման վճար" value={monthlyFee} suffix={<Icon type="dram" size={17} />} />
          {terms.requiredGuarantorCount > 0 &&
            <PlateCard className="column small-12 medium-3" label="Երաշխավորների քանակ" value={terms.requiredGuarantorCount} suffix="անձ" />
          }
          {terms.onlyCapitalMaturePeriod > 0 &&
            <PlateCard className="column small-12 medium-3" label="Մայր գումարի մարման արտոնյալ ժամանակահատված" value={terms.onlyCapitalMaturePeriod} suffix="ամիս" />
          }
          {terms.onlyInterestMaturePeriod > 0 &&
            <PlateCard className="column small-12 medium-3" label="Տոկոսների մարման արտոնյալ ժամանակահատված" value={terms.onlyInterestMaturePeriod} suffix="ամիս" />
          }
        </div>
      </div>
      </>
    )
  }
}

const mapStateToProps = (state) => ({
  actions: state.applicationReducer.dictionary.actions,
  selectedActionId: state.applicationReducer.customer_info_for_save.request.action,
});

const mapDispatchToProps = (dispatch) => ({
  initLoad: () => dispatch(initLoad()),
});

export default connect(mapStateToProps, mapDispatchToProps)(OfferTerms);
